<template functionnal>
  <svg
    id="svg45"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    version="1.1"
    width="500"
    height="275"
    viewBox="0 0 500 275"
    sodipodi:docname="31WOoATKFPL._AC.svg"
    inkscape:version="0.92.4 (f8dce91, 2019-08-02)"
  >
    <g id="layer1" inkscape:groupmode="layer" inkscape:label="Layer 1">
      <ellipse
        id="path108"
        style="fill: #616161; stroke-width: 1.0263021"
        ry="175.73433"
        rx="190.24236"
        cy="153.55377"
        cx="275.88654"
      />
    </g>
    <g id="layer2" inkscape:groupmode="layer" inkscape:label="Layer 2">
      <path
        id="path55"
        fill="#fff"
        d="m 167.68112,187.71115 7.21098,-5.44251 -1.35206,-3.51129 0.30046,
        -1.75565 4.80732,-3.68686 1.95298,1.75565 0.60091,-0.87783
        -1.0516,-2.98459 4.50686,-3.5113 2.1032,2.80903 1.50229,
        -0.70225 -1.35206,-3.86243 5.55846,-4.56468 -3.1548,-7.90042
        8.71327,-6.14476 8.11235,-1.93122 12.31877,-5.09138 13.82104,
        -8.25154 14.57219,-9.83163 10.51601,-7.90041 10.06532,-8.95381
        c 0,0 5.22673,-8.558269 7.49634,-9.728782 5.13042,-2.645928 8.44718,
        -1.853988 8.42792,-1.858492 l 10.9667,-2.106778 13.97127,-3.160167
        13.0699,-3.862427 39.96085,1.053389 h 1.35206 l -0.45069,2.809038
        -2.55388,3.160167 -2.5539,2.106778 13.67082,0.877823 h 1.20183 l
        0.75114,2.809038 -2.10319,6.144763 -3.15481,0.70226 -0.30046,
        -4.03799 -14.27173,-0.526694 0.60092,4.389124 18.62836,1.58008
        6.30961,-15.098571 1.50229,-1.580083 h 1.65251 l 0.75114,1.580083
        -5.258,16.151961 -0.30046,2.80903 c 0,0 1.7065,4.72449 2.25344,
        7.19816 1.21727,5.50542 1.82851,16.85422 1.82851,16.85422 l
        0.42491,8.25155 -0.45068,6.14476 -0.75114,2.10678 0.45068,
        1.93122 0.42491,12.25638 -1.20183,0.70225 -26.74072,-1.05338
        -2.40366,-0.17556 -13.0699,0.87782 -0.75114,1.05339 -1.95298,
        0.35113 -11.26715,-1.58009 -17.42654,-3.16016 -10.06533,-3.5113
        -3.60549,-1.58008 -3.60549,-4.21355 -4.65708,-2.45792 -5.10779,
        0.35114 -3.75571,1.40452 -4.95755,4.38912 -2.10321,1.05338
        -2.55389,0.17556 h -4.35663 l -1.95297,0.70227 -1.95298,1.58008
        -1.50228,2.10678 -1.95298,2.28233 -2.25343,1.40452 -2.85435,
        0.87783 c 0,0 -2.53842,0.69557 -3.75572,1.22895 -1.0906,0.47787
        -3.1548,1.75565 -3.1548,1.75565 -1.09296,-0.42856 -2.85435,2.28235
        -2.85435,2.28235 l -1.50228,3.86242 -1.80275,1.75565 -2.40366,1.58008
        -2.70412,0.52669 -2.70411,2.10678 -4.35664,5.26694 -2.70412,3.86243
        -3.90594,7.37372 -1.5023,2.45791 -1.80274,1.40452 -2.1032,0.70226
        -2.85434,-0.87783 -0.90138,-1.40452 -1.80275,-3.16016 -6.45983,
        3.68685 -2.25343,-3.16016 -1.05161,1.05339 1.05161,2.9846
        -4.80732,2.9846 -1.35206,-1.75564 -1.50229,0.52669 0.30046,
        2.80903 -5.10778,3.16017 -2.70412,-3.86242 -6.91052,5.26694 z"
        inkscape:connector-curvature="0"
        sodipodi:nodetypes="cccccccccccccccccccccsccccccccccccccccccccccccsccccccccccccccccccc
        cccccccccccssccccccccccccccccccccccccccc"
      />
      <path
        id="path59"
        fill="#000"
        d="m 353.47365,104.13601 c 6.31018,19.97953 6.48262,40.88566 4.76653,60.8652"
        inkscape:connector-curvature="0"
        sodipodi:nodetypes="cc"
      />
      <path
        id="path57"
        fill="#000"
        d="m 352.91318,99.753196 6.7603,-8.075978"
        inkscape:connector-curvature="0"
      />
    </g>
  </svg>
</template>
